// The dial's own text (SPEC-redesign §10.13, D-9). Pure, and its own module so
// it can be unit-tested on its own terms: `src/wheel.ts` stands up a map, a
// canvas and the data seam, and none of that is needed to read a sentence.
import { distanceLabel } from '../shared/geo.ts';
import type { ViewState } from '../state/viewstate.ts';

/**
 * „moje linie 16, 99, promień 3,0 km", or „promień 800 m" when the resident has
 * saved no line.
 *
 * Every SAVED line is listed, running or not, in the order it was added, each
 * once. That is a declared deviation from the prototype, whose `dialText` is
 * `mine.map(v => v.line)` over the running vehicles: feed-ordered, and one
 * entry per vehicle, so two vehicles of line 221 read „221, 221". It also
 * matches §3.1 row 08, where the kreska names a saved line precisely when it
 * has nothing on the road.
 *
 * The radius uses the same formatter as the rings, the radius strip and the
 * distance column — one distance format in the app, and the fitness function in
 * `src/geo.test.ts` is what keeps it one (#192).
 */
function dialSummary(view: ViewState): string {
  const radius = distanceLabel(view.radius);
  return view.lines.length > 0
    ? `moje linie ${view.lines.join(', ')}, promień ${radius}`
    : `promień ${radius}`;
}

/** The whole two-line label, „Dotknij…" verbatim from the prototype. */
export const dialText = (view: ViewState): string =>
  `Tarcza: ${dialSummary(view)}\nDotknij, żeby wrócić do koła.`;
